<template>
    <button
        class="el-button"
        :disabled="disabled"
        :class="buttonClasses"
        @mouseenter="handleMouseEnter"
        @click="handleClick"
        @focus="handleMouseEnter"
        :style="styles"
        v-bind="attrs"
    >
        <div class="el-button__animation_border"></div>
        <div
            v-if="$slots['icon-left']"
            class="el-button__icon el-button__icon--left"
        >
            <slot name="icon-left"></slot>
        </div>
        <span v-if="$slots.default" class="el-button__text">
            <slot />
        </span>
        <div
            v-if="$slots['icon-right']"
            class="el-button__icon el-button__icon--right"
        >
            <slot name="icon-right"></slot>
        </div>
        <div v-if="loading" class="el-button__icon el-button__icon--loading">
            <iLoading />
        </div>
    </button>
</template>

<script>
import iLoading from "../paymentModal/icons/ILoading.vue";

export default {
    name: "ElButton",
    components: { iLoading },
    props: {
        type: {
            type: String,
            default: "default",
            validator: (value) => ["default", "grey"].includes(value),
        },
        size: {
            type: String,
            default: "large",
            validator: (value) => ["small", "medium", "large"].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        circle: {
            type: Boolean,
            default: false,
        },
        simple: {
            type: Boolean,
            default: false,
        },
        square: {
            type: Boolean,
            default: false,
        },
        attrs: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            styles: {
                "--size-square": "0px",
            },
        };
    },
    computed: {
        buttonClasses() {
            return {
                "is-disabled": this.disabled,
                "is-loading": this.loading,
                "is-circle": this.circle,
                "is-simple": this.simple,
                "is-square": this.square,
                [`is-${this.size}`]: true,
                [`type-${this.type}`]: true,
            };
        },
    },
    methods: {
        handleMouseEnter(event) {
            if (this.disabled || this.loading || !event) return;
            const button = event.currentTarget;
            if (!button) return;
            const buttonStyles = getComputedStyle(button);

            const width = this.square
                ? this.convertToNumber(buttonStyles.width) + 20
                : this.convertToNumber(buttonStyles.width);

            this.styles = {
                "--size-square": `${width}px`,
            };
        },
        handleClick(event) {
            // Убедимся, что стиль обновляется корректно при клике
            setTimeout(() => this.handleMouseEnter(event), 0);
        },
        convertToNumber(value) {
            const parsedValue = parseFloat(value);
            return isNaN(parsedValue) ? 0 : parsedValue;
        },
    },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
